import React, { useState } from 'react'
import dynamic from 'next/dynamic'

import type { Board } from '../Collection/RoomsCollection'
import RoomsCollection from '../Collection/RoomsCollection'

import styles from './styles.module.css'

const Header = dynamic(() => import('../RoomResponsive/AvailabilityHeader'))

interface IRoomsAvailability {
  defaultOpen?: boolean
  showHeader?: boolean
  rooms: Board[]
}

const RoomsAvailability = ({
  defaultOpen = true,
  showHeader = false,
  rooms = [],
}: IRoomsAvailability) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  const { adults, children, roomsNumber, childrenAges, beds } = rooms[0]

  return (
    <div className={styles.roomAvailability}>
      {showHeader && (
        <Header
          adults={adults}
          children={children}
          roomsNumber={roomsNumber}
          childrenAges={childrenAges}
          beds={beds}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        />
      )}
      <RoomsCollection
        isOpen={isOpen}
        closeGroup={() => setIsOpen(false)}
        rooms={rooms}
        withHeader={showHeader}
      />
    </div>
  )
}

export default RoomsAvailability
